import React, { useEffect, useState, useCallback } from "react";
import "./FifthStrikeOptionChain.css";
import { environment } from "environment/environment";
import useNiftyWebsocket from "service/websocket/NiftyWebsocketApi";
import usePageTitle from "component/common/PageTitle";

export default function FifthStrikeOptionChain() {
  // WebSocket connection
  const { options } = useNiftyWebsocket(environment.niftyWebsocketUrl);

  const [indexSymbolName, setIndexSymbolName] = useState(null);
  const [indexDayRangeData, setIndexDayRangeData] = useState(null);
  const [niftyOptionDataModelList, setNiftyOptionDataModelList] = useState([]);
  const [selectedStrikeFilter, setSelectedStrikeFilter] = useState("6");
  const [aboveSpotIndex, setAboveSpotIndex] = useState(null);
  const [belowSpotIndex, setBelowSpotIndex] = useState(null);
  const [filter5thStrikeNiftyOptionDataList, setFilter5thStrikeNiftyOptionDataModelList] = useState(null);
  const [indexFilterValueChanges, setIndexFilterValueChangeFilter] = useState("NSE:NIFTY");
  // =======================
  // Stats State
  // =======================
  const [stats, setStats] = useState({
    spotPrice: null,
    highestCallVolume: null,
    secondHighestCallVolume: null,
    highestPutVolume: null,
    secondHighestPutVolume: null,
    highestCallOi: null,
    secondHighestCallOi: null,
    highestPutOi: null,
    secondHighestPutOi: null,
    highestCallOiChg: null,
    secondHighestCallOiChg: null,
    highestPutOiChg: null,
    secondHighestPutOiChg: null,
    highestCall3MOIChange: null,
    secondHighestCall3MOIChange: null,
    highestPut3MOIChange: null,
    secondHighestPut3MOIChange: null,
    highestCallTikVolumeChange: null,
    secondHighestCallTikVolumeChange: null,
    highestPutTikVolumeChange: null,
    secondHighestPutTikVolumeChange: null,
    highestCall3MVolumeChange: null,
    secondHighestCall3MVolumeChange: null,
    highestPut3MVolumeChange: null,
    secondHighestPut3MVolumeChange: null,
    highestCall3MOICHGChange: null,
    secondHighestCall3MOICHGChange: null,
    highestPut3MOICHGChange: null,
    secondHighestPut3MOICHGChange: null,

    highestCallVolStrike: null,
    secondHighestCallVolStrike: null,
    highestCallOiStrike: null,
    secondHighestCallOiStrike: null,
    highestCallOiChgStrike: null,
    secondHighestCallOiChgStrike: null,
    highestPutVolStrike: null,
    secondHighestPutVolStrike: null,
    highestPutOiStrike: null,
    secondHighestPutOiStrike: null,
    highestPutOiChgStrike: null,
    secondHighestPutOiChgStrike: null,

    callResistance: null,
    callResistanceWttAndWtb: null,
    callResistanceOIWttAndWtb: null,
    callResistanceOIChgWttAndWtb: null,
    callResistanceOIChgWttAndWtb: null,

    putSupport: null,
    putSupportWttAndWtb: null,
    putSupportOIWttAndWtb: null,
    putSupportOIChgWttAndWtb: null,

    callTotalVolumeSum: null,
    callTotalOISum: null,
    callTotalOICHGSum: null,

    putTotalVolumeSum: null,
    putTotalOISum: null,
    putTotalOICHGSum: null,
  });

  const [stats5thStrikeData, set5thStrikeData] = useState({
    call5thStrikeTotalVolumeSum: null,
    call5thStrikeTotalOISum: null,
    call5thStrikeTotalOICHGSum: null,

    put5thStrikeTotalVolumeSum: null,
    put5thStrikeTotalOISum: null,
    put5thStrikeTotalOICHGSum: null,

  });
  // Percentage Helpers
  // =======================
  const getPercentage = (value, highest) => highest ? ((value / highest) * 100).toFixed(2) : "0";

  // =======================

  // Resistance Logic
  // =======================
  const getCallResistanceLogic = useCallback((highestCallVolStrike, highestCallOiStrike, spotPrice) => {
    if (highestCallVolStrike == null || highestCallOiStrike == null) return null;

    if (!highestCallVolStrike || !highestCallOiStrike) return null;

    if (highestCallVolStrike === highestCallOiStrike) return highestCallVolStrike;

    const volDiff = Math.abs(highestCallVolStrike - spotPrice);
    const oiDiff = Math.abs(highestCallOiStrike - spotPrice);
    return volDiff < oiDiff ? highestCallVolStrike : highestCallOiStrike;
  }, []);

  const getCallResistanceWttAndWtb = useCallback((callResistance, secondHighestCallVolStrike, secondHighestCallVolume, highestCallVolume) => {
    if (!callResistance || !secondHighestCallVolStrike || !secondHighestCallVolume) return "N/A";

    const percentage = getPercentage(secondHighestCallVolume, highestCallVolume);
    const per = parseFloat(percentage);

    if (secondHighestCallVolStrike < callResistance) return per >= 75 ? `WTB - ${percentage}%` : "STRNG";
    return per >= 75 ? `WTT - ${percentage}%` : "STRNG";
  }, []);

  // React-compatible version
  const getCallResistanceOIWttAndWtb = useCallback((secondHighestCallOIStrike, secondHighestCallOI, highestCallOIStrike) => {
    let callResistanceOIWttAndWtb = "";
    if (highestCallOIStrike != null && secondHighestCallOIStrike != null && secondHighestCallOIStrike < highestCallOIStrike) {
      const percentage = getCallOiPercentage(secondHighestCallOI);
      const per = parseInt(percentage);
      if (per >= 75) {
        callResistanceOIWttAndWtb = `WTB - ${percentage}`;
        // console.log("Resistance OI is =>", callResistanceOIWttAndWtb);
      } else {
        callResistanceOIWttAndWtb = `STRNG`;
        // console.log("Resistance OI is =>", callResistanceOIWttAndWtb);
      }
    } else {
      const percentage = getCallOiPercentage(secondHighestCallOI);
      const per = parseInt(percentage);
      if (per >= 75) {
        callResistanceOIWttAndWtb = `WTT - ${percentage}`;
      } else {
        callResistanceOIWttAndWtb = `STRNG`;
      }
      // console.log("Resistance OI is =>", callResistanceOIWttAndWtb);
    }

    return callResistanceOIWttAndWtb;
  }, []);

  // React-compatible version
  const getCallResistanceOIChgWttAndWtb = useCallback((secondHighestCallOIChgStrike, secondHighestCallOIChg, highestOIChgStrike) => {
    let callResistanceOIChgWttAndWtb = "";
    if (highestOIChgStrike != null && secondHighestCallOIChgStrike != null && secondHighestCallOIChgStrike < highestOIChgStrike) {
      const percentage = getCallOiChgPercentage(secondHighestCallOIChg);
      const per = parseInt(percentage);
      if (per >= 75) {
        callResistanceOIChgWttAndWtb = `WTB - ${percentage}`;
        // console.log("Resistance OICHG is =>", callResistanceOIChgWttAndWtb);
      } else {
        callResistanceOIChgWttAndWtb = `STRNG`;
        // console.log("Resistance OICHG is =>", callResistanceOIChgWttAndWtb);
      }
    } else {
      const percentage = getCallOiChgPercentage(secondHighestCallOIChg);
      const per = parseInt(percentage);
      if (per >= 75) {
        callResistanceOIChgWttAndWtb = `WTT - ${percentage}`;
      } else {
        callResistanceOIChgWttAndWtb = `STRNG`;
      }
     // console.log("Resistance OICHG is =>", callResistanceOIChgWttAndWtb);
    }

    return callResistanceOIChgWttAndWtb;
  }, []);

  // React-compatible version
  const getPutSupportLogic = useCallback((highestPutVolStrike, highestPutOiStrike, spotPrice) => {
    let putSupport = null;
    // 🧱 Support Logic
    if (highestPutVolStrike != null && highestPutOiStrike != null) {
      if (highestPutVolStrike === highestPutOiStrike) {
        putSupport = highestPutVolStrike;
      } else {
        const volDiff = Math.abs(highestPutVolStrike - spotPrice);
        const oiDiff = Math.abs(highestPutOiStrike - spotPrice);
        putSupport = volDiff < oiDiff ? highestPutVolStrike : highestPutOiStrike;
      }
     // console.log("putSupport =>", putSupport);
    }

    return putSupport;
  }, []);

  // React-compatible version
  const getPutSupportWttAndWtb = useCallback((secondHighestPutVolStrike, secondHighestPutVolume, putSupport) => {
    let putSupportWttAndWtb = "";
    if (putSupport != null && secondHighestPutVolStrike != null && secondHighestPutVolStrike < putSupport) {
      const percentage = getPutVolumePercentage(secondHighestPutVolume);
      const per = parseInt(percentage);
      if (per >= 75) {
        putSupportWttAndWtb = `WTB - ${percentage}`;
      //  console.log("Support is =>", putSupportWttAndWtb);
      } else {
        putSupportWttAndWtb = `STRNG`;
     //   console.log("Support is =>", putSupportWttAndWtb);
      }
    } else {
      const percentage = getPutVolumePercentage(secondHighestPutVolume);
      const per = parseInt(percentage);
      if (per >= 75) {
        putSupportWttAndWtb = `WTT - ${percentage}`;
      } else {
        putSupportWttAndWtb = `STRNG`;
      }
      //console.log("Support is =>", putSupportWttAndWtb);
    }
    return putSupportWttAndWtb;
  }, []);

  // ✅ React-compatible version
  const getPutSupportOIWttAndWtb = useCallback((secondHighestPutOIStrike, secondHighestPutOI, highestPutOIStrike) => {
    let putSupportOIWttAndWtb = "";
    if (highestPutOIStrike != null && secondHighestPutOIStrike != null && secondHighestPutOIStrike < highestPutOIStrike) {
      const percentage = getPutOiPercentage(secondHighestPutOI);
      const per = parseInt(percentage);
      if (per >= 75) {
        putSupportOIWttAndWtb = `WTB - ${percentage}`;
       // console.log("Support OI is =>", putSupportOIWttAndWtb);
      } else {
        putSupportOIWttAndWtb = `STRNG`;
       // console.log("Support OI is =>", putSupportOIWttAndWtb);
      }
    } else {
      const percentage = getPutOiPercentage(secondHighestPutOI);
      const per = parseInt(percentage);
      if (per >= 75) {
        putSupportOIWttAndWtb = `WTT - ${percentage}`;
      } else {
        putSupportOIWttAndWtb = `STRNG`;
      }
     // console.log("Support OI is =>", putSupportOIWttAndWtb);
    }
    return putSupportOIWttAndWtb;
  }, []);

  // ✅ React-compatible version
  const getPutSupportOIChgWttAndWtb = useCallback((secondHighestPutOIChgStrike, secondHighestPutOIChg, highestPutOIChgStrike) => {
    let putSupportOIChgWttAndWtb = "";
    if (highestPutOIChgStrike && secondHighestPutOIChgStrike != null && secondHighestPutOIChgStrike < highestPutOIChgStrike) {
      const percentage = getPutOiChgPercentage(secondHighestPutOIChg);
      const per = parseInt(percentage);
      if (per >= 75) {
        putSupportOIChgWttAndWtb = `WTB - ${percentage}`;
       // console.log("Support OICHG is =>", putSupportOIChgWttAndWtb);
      } else {
        putSupportOIChgWttAndWtb = `STRNG`;
       // console.log("Support OICHG is =>", putSupportOIChgWttAndWtb);
      }
    } else {
      const percentage = getPutOiChgPercentage(secondHighestPutOIChg);
      const per = parseInt(percentage);
      if (per >= 75) {
        putSupportOIChgWttAndWtb = `WTT - ${percentage}`;
      } else {
        putSupportOIChgWttAndWtb = `STRNG`;
      }
     // console.log("Support OICHG is =>", putSupportOIChgWttAndWtb);
    }
    return putSupportOIChgWttAndWtb;
  }, []);

  // Main Update Function
  // =======================
  const updateTopCallVolumes = useCallback(
    (optionData = []) => {
      if (!Array.isArray(optionData) || optionData.length === 0) return;

      const sortDesc = (arr) => [...new Set(arr)].sort((a, b) => b - a);
      const extract = (key) => optionData.map((row) => row[key]).filter((v) => v != null);
      const findStrike = (key, value) => optionData.find((row) => row[key] === value)?.strikePrice ?? null;

      const spotPrice = optionData[0]?.spotPrice || 0;

      const sortedCallVol = sortDesc(extract("ceVolume"));
      const sortedPutVol = sortDesc(extract("peVolume"));
      const sortedCallOi = sortDesc(extract("ceOI"));
      const sortedPutOi = sortDesc(extract("peOI"));
      const sortedCallOiChg = sortDesc(extract("ceOIChg"));
      const sortedPutOiChg = sortDesc(extract("peOIChg"));
      const sortedCall3MOIChange = sortDesc(extract("ce3MOIChange"));
      const sortedPut3MOIChange = sortDesc(extract("pe3MOIChange"));
      const sortedCallTikVolChange = sortDesc(extract("ceTikByTikVolumeChange"));
      const sortedPutTikVolChange = sortDesc(extract("peTikByTikVolumeChange"));
      const sortedCall3MVolumeChange = sortDesc(extract("ce3MVolumeChange"));
      const sortedPut3MVolumeChange = sortDesc(extract("pe3MVolumeChange"));
      const sortedCall3MOIChgChange = sortDesc(extract("ce3MOICHGChange"));
      const sortedPut3MOIChgChange = sortDesc(extract("pe3MOICHGChange"));

      const updatedStats = {
        spotPrice,
        highestCallVolume: sortedCallVol[0] ?? null,
        secondHighestCallVolume: sortedCallVol[1] ?? null,
        highestPutVolume: sortedPutVol[0] ?? null,
        secondHighestPutVolume: sortedPutVol[1] ?? null,
        highestCallOi: sortedCallOi[0] ?? null,
        secondHighestCallOi: sortedCallOi[1] ?? null,
        highestPutOi: sortedPutOi[0] ?? null,
        secondHighestPutOi: sortedPutOi[1] ?? null,
        highestCallOiChg: sortedCallOiChg[0] ?? null,
        secondHighestCallOiChg: sortedCallOiChg[1] ?? null,
        highestPutOiChg: sortedPutOiChg[0] ?? null,
        secondHighestPutOiChg: sortedPutOiChg[1] ?? null,
        highestCall3MOIChange: sortedCall3MOIChange[0] ?? null,
        secondHighestCall3MOIChange: sortedCall3MOIChange[1] ?? null,
        highestPut3MOIChange: sortedPut3MOIChange[0] ?? null,
        secondHighestPut3MOIChange: sortedPut3MOIChange[1] ?? null,
        highestCallTikVolumeChange: sortedCallTikVolChange[0] ?? null,
        secondHighestCallTikVolumeChange: sortedCallTikVolChange[1] ?? null,
        highestPutTikVolumeChange: sortedPutTikVolChange[0] ?? null,
        secondHighestPutTikVolumeChange: sortedPutTikVolChange[1] ?? null,
        highestCall3MVolumeChange: sortedCall3MVolumeChange[0] ?? null,
        secondHighestCall3MVolumeChange: sortedCall3MVolumeChange[1] ?? null,
        highestPut3MVolumeChange: sortedPut3MVolumeChange[0] ?? null,
        secondHighestPut3MVolumeChange: sortedPut3MVolumeChange[1] ?? null,
        highestCall3MOICHGChange: sortedCall3MOIChgChange[0] ?? null,
        secondHighestCall3MOICHGChange: sortedCall3MOIChgChange[1] ?? null,
        highestPut3MOICHGChange: sortedPut3MOIChgChange[0] ?? null,
        secondHighestPut3MOICHGChange: sortedPut3MOIChgChange[1] ?? null,

        highestCallVolStrike: findStrike("ceVolume", sortedCallVol[0]),
        secondHighestCallVolStrike: findStrike("ceVolume", sortedCallVol[1]),
        highestCallOiStrike: findStrike("ceOI", sortedCallOi[0]),
        secondHighestCallOiStrike: findStrike("ceOI", sortedCallOi[1]),
        highestCallOiChgStrike: findStrike("ceOIChg", sortedCallOiChg[0]),
        secondHighestCallOiChgStrike: findStrike("ceOIChg", sortedCallOiChg[1]),

        highestPutVolStrike: findStrike("peVolume", sortedPutVol[0]),
        secondHighestPutVolStrike: findStrike("peVolume", sortedPutVol[1]),
        highestPutOiStrike: findStrike("peOI", sortedPutOi[0]),
        secondHighestPutOiStrike: findStrike("peOI", sortedPutOi[1]),
        highestPutOiChgStrike: findStrike("peOIChg", sortedPutOiChg[0]),
        secondHighestPutOiChgStrike: findStrike("peOIChg", sortedPutOiChg[1]),

        callTotalVolumeSum: sortedCallVol.reduce((sum, val) => sum + val, 0),
        callTotalOISum: sortedCallOi.reduce((sum, val) => sum + val, 0),
        callTotalOICHGSum: sortedCallOiChg.reduce((sum, val) => sum + val, 0),

        putTotalVolumeSum: sortedPutVol.reduce((sum, val) => sum + val, 0),
        putTotalOISum: sortedPutOi.reduce((sum, val) => sum + val, 0),
        putTotalOICHGSum: sortedPutOiChg.reduce((sum, val) => sum + val, 0),

      };

      // Derived logic
      updatedStats.callResistance = getCallResistanceLogic(updatedStats.highestCallVolStrike, updatedStats.highestCallOiStrike, spotPrice);
      updatedStats.callResistanceWttAndWtb = getCallResistanceWttAndWtb(updatedStats.callResistance, updatedStats.secondHighestCallVolStrike, updatedStats.secondHighestCallVolume, updatedStats.highestCallVolume);
      updatedStats.callResistanceOIWttAndWtb = getCallResistanceOIWttAndWtb(updatedStats.secondHighestCallOiStrike, updatedStats.secondHighestCallOi, updatedStats.highestCallOiStrike);
      updatedStats.callResistanceOIChgWttAndWtb = getCallResistanceOIChgWttAndWtb(updatedStats.secondHighestCallOiChgStrike, updatedStats.secondHighestCallOiChg, updatedStats.highestCallOiChgStrike);

      updatedStats.putSupport = getPutSupportLogic(updatedStats.highestPutVolStrike, updatedStats.highestPutOiStrike, spotPrice);
      updatedStats.putSupportWttAndWtb = getPutSupportWttAndWtb(updatedStats.secondHighestPutVolStrike, updatedStats.secondHighestPutVolume, updatedStats.putSupport);
      updatedStats.putSupportOIWttAndWtb = getPutSupportOIWttAndWtb(updatedStats.secondHighestPutOiStrike, updatedStats.secondHighestPutOi, updatedStats.highestPutOiStrike);
      updatedStats.putSupportOIChgWttAndWtb = getPutSupportOIChgWttAndWtb(updatedStats.secondHighestPutOiChgStrike, updatedStats.secondHighestPutOiChg, updatedStats.highestPutOiChgStrike);

      setStats(updatedStats);
    },
    [getCallResistanceLogic, getCallResistanceWttAndWtb, getCallResistanceOIWttAndWtb, getCallResistanceOIChgWttAndWtb, getPutSupportLogic, getPutSupportWttAndWtb, getPutSupportOIWttAndWtb, getPutSupportOIChgWttAndWtb]
  );

  const update5thStrikeTotalData = useCallback(
    (optionData = []) => {
      if (!Array.isArray(optionData) || optionData.length === 0) return;

      const sortDesc = (arr) => [...new Set(arr)].sort((a, b) => b - a);
      const extract = (key) => optionData.map((row) => row[key]).filter((v) => v != null);
     // const findStrike = (key, value) => optionData.find((row) => row[key] === value)?.strikePrice ?? null;

      const spotPrice = optionData[0]?.spotPrice || 0;

      const sortedCallVol = sortDesc(extract("ceVolume"));
      const sortedPutVol = sortDesc(extract("peVolume"));
      const sortedCallOi = sortDesc(extract("ceOI"));
      const sortedPutOi = sortDesc(extract("peOI"));
      const sortedCallOiChg = sortDesc(extract("ceOIChg"));
      const sortedPutOiChg = sortDesc(extract("peOIChg"));
      
      const updatedStats = {
        call5thStrikeTotalVolumeSum: sortedCallVol.reduce((sum, val) => sum + val, 0),
        call5thStrikeTotalOISum: sortedCallOi.reduce((sum, val) => sum + val, 0),
        call5thStrikeTotalOICHGSum: sortedCallOiChg.reduce((sum, val) => sum + val, 0),

        put5thStrikeTotalVolumeSum: sortedPutVol.reduce((sum, val) => sum + val, 0),
        put5thStrikeTotalOISum: sortedPutOi.reduce((sum, val) => sum + val, 0),
        put5thStrikeTotalOICHGSum: sortedPutOiChg.reduce((sum, val) => sum + val, 0),

      };
      set5thStrikeData(updatedStats);
    },[]);

  // -------------------
  // Fetch WebSocket Data
  // -------------------
  useEffect(() => {
    const niftyData = options?.[indexFilterValueChanges];
    if (!niftyData) return;

    if (niftyData.indexDayRange) setIndexDayRangeData(niftyData.indexDayRange);

    if (Array.isArray(niftyData.optionDataModelList)) {
      const niftyOptionDataList = niftyData.optionDataModelList;
      // stats.spotPrice(niftyOptionDataList[0]?.spotPrice || 0);
      setIndexSymbolName(niftyOptionDataList[0].indexSymbol);
      const filtered = filterNiftyOptionData(niftyOptionDataList, niftyOptionDataList[0]?.spotPrice || 0);
      prepareStrikeMarkers(filtered, niftyOptionDataList[0]?.spotPrice || 0);
      setNiftyOptionDataModelList(filtered);
      updateTopCallVolumes(filtered); // merged top volumes & OI logic
      setFilter5thStrikeNiftyOptionDataModelList(filter5thStrikeNiftyOptionData(filtered, niftyOptionDataList[0]?.spotPrice || 0));
      console.log('niftyOptionDataModelList => ', filtered);
      console.log('Top Call/Put stats => ', stats);
      update5thStrikeTotalData(filter5thStrikeNiftyOptionDataList);
      console.log('stats5thStrikeData => ', stats5thStrikeData);
    }
  }, [options, selectedStrikeFilter, updateTopCallVolumes]);

  // -------------------
  // Filter Option Data
  // -------------------
  const filterNiftyOptionData = (data, spot) => {
    if (!spot || selectedStrikeFilter === "ALL") return data;

    if(!spot || selectedStrikeFilter === "6"){
    return strikeFilterData(data, spot, selectedStrikeFilter)
    }
    if(!spot || selectedStrikeFilter === "3"){
    return strikeFilterData(data, spot, selectedStrikeFilter)
    }
  };

  const strikeFilterData=(data,spot, strikeCount)=>{
    const range = Number(strikeCount - 1);
    const closestIndex = data.reduce((closestIdx, curr, idx) =>
      Math.abs(curr.strikePrice - spot) < Math.abs(data[closestIdx].strikePrice - spot)
        ? idx : closestIdx, 0);
    const start = Math.max(0, closestIndex - range);
    const end = Math.min(data.length - 1, closestIndex + range);
    return data.slice(start-1, end + 1);
  }

  const filter5thStrikeNiftyOptionData = (data, spot) => {
    const range = Number(4);
    const closestIndex = data.reduce((closestIdx, curr, idx) =>
      Math.abs(curr.strikePrice - spot) < Math.abs(data[closestIdx].strikePrice - spot)
        ? idx : closestIdx, 0);
    const start = Math.max(0, closestIndex - range);
    const end = Math.min(data.length - 1, closestIndex + range);
    return data.slice(start, end + 2);
  };
  // -------------------
  // Prepare Strike Markers
  // -------------------
  const prepareStrikeMarkers = (list, spot) => {
    let aboveIndex = null;
    let belowIndex = null;

    if (selectedStrikeFilter === "ALL" || selectedStrikeFilter === "10") {
      for (let i = 0; i < list.length; i++) {
        const row = list[i];

        if (
          belowIndex === null && row.strikePrice < spot && list[i + 5] &&
          list[i + 5].strikePrice >= spot
        ) {
          belowIndex = i;
        }
        if (aboveIndex === null && row.strikePrice > spot && i >= 3 &&
          list[i - 3].strikePrice >= spot
        ) {
          aboveIndex = i;
        }

        if (belowIndex !== null && aboveIndex !== null) break;
      }
    }

    setBelowSpotIndex(belowIndex);
    setAboveSpotIndex(aboveIndex);
  };

  const handleStrikeFilterChange = (event) => {
    setSelectedStrikeFilter(event.target.value);
  };

  const handleIndexFilterValueChange = (event) => {
    setIndexFilterValueChangeFilter(event.target.value);
  };

  // Percentage Helper Functions
  // =======================
  const getCallVolumePercentage = (volume) =>
    stats.highestCallVolume && volume ? ((volume / stats.highestCallVolume) * 100).toFixed(2) + "%" : "0%";

  const getPutVolumePercentage = (volume) => stats.highestPutVolume && volume ? ((volume / stats.highestPutVolume) * 100).toFixed(2) + "%"
    : "0%";

  const getCallOiPercentage = (oi) => stats.highestCallOi && oi ? ((oi / stats.highestCallOi) * 100).toFixed(2) + "%"
    : "0%";

  const getPutOiPercentage = (oi) => stats.highestPutOi && oi ? ((oi / stats.highestPutOi) * 100).toFixed(2) + "%"
    : "0%";

  const getCallOiChgPercentage = (val) => stats.highestCallOiChg && val ? ((val / stats.highestCallOiChg) * 100).toFixed(2) + "%"
    : "0%";

  const getPutOiChgPercentage = (val) => stats.highestPutOiChg && val ? ((val / stats.highestPutOiChg) * 100).toFixed(2) + "%"
    : "0%";

  const getCall3MOIPercentage = (val) => stats.highestCall3MOIChange && val ? ((val / stats.highestCall3MOIChange) * 100).toFixed(2) + "%"
    : "0%";

  const getCall3MOICHGPercentage = (val) => stats.highestCall3MOIChange && val ? ((val / stats.highestCall3MOIChange) * 100).toFixed(2) + '%' : '0%';

  const getPut3MOIPercentage = (val) => stats.highestPut3MOIChange && val ? ((val / stats.highestPut3MOIChange) * 100).toFixed(2) + "%"
    : "0%";
  const getPut3MOICHGPercentage = (val) => stats.highestPut3MOIChange && val ? ((val / stats.highestPut3MOIChange) * 100).toFixed(2) + '%' : '0%';
  const getCallTikVolumePercentage = (val) => stats.highestCallTikVolumeChange && val ? ((val / stats.highestCallTikVolumeChange) * 100).toFixed(2) + "%"
    : "0%";
  const getPutTikVolumePercentage = (val) => stats.highestPutTikVolumeChange && val ? ((val / stats.highestPutTikVolumeChange) * 100).toFixed(2) + "%"
    : "0%";
  const getCall3MVolumePercentage = (val) => stats.highestCall3MVolumeChange && val ? ((val / stats.highestCall3MVolumeChange) * 100).toFixed(2) + '%' : '0%';
  const getPut3MVolumePercentage = (val) => stats.highestPut3MVolumeChange && val ? ((val / stats.highestPut3MVolumeChange) * 100).toFixed(2) + '%' : '0%';

  //highest and 2nd highest class changes dynamically

  const getCallVolumeClass = (volume) => {
    let highestVolume = stats.highestCallVolume;
    let secondHighestVolume = stats.secondHighestCallVolume;
    if (!highestVolume || !volume) return '';

    const pct = (volume / highestVolume) * 100;

    if (volume === highestVolume) return 'call-volume-blue';
    if (volume === secondHighestVolume && pct >= 75) return 'call-volume-yellow';
    if (pct >= 75 && volume < (secondHighestVolume ?? Infinity)) return 'call-volume-bold';

    return '';
  };

  // === Volume Classes ===
  const getPutVolumeClass = (volume) => {
    let highestVolume = stats.highestPutVolume;
    let secondHighestVolume = stats.secondHighestPutVolume;
    if (!highestVolume || !volume) return '';
    const pct = (volume / highestVolume) * 100;
    if (volume === highestVolume) return 'put-volume-blue';
    if (volume === secondHighestVolume && pct >= 75) return 'put-volume-yellow';
    if (pct >= 75 && volume < (secondHighestVolume ?? Infinity)) return 'put-volume-bold';
    return '';
  };

  // === Call OI Classes ===
  const getCallOiClass = (oi) => {
    let highestOI = stats.highestCallOi;
    let secondHighestOI = stats.secondHighestCallOi;
    if (!highestOI || !oi) return '';
    const pct = (oi / highestOI) * 100;
    if (oi === highestOI) return 'call-oi-blue';
    if (oi === secondHighestOI && pct >= 75) return 'call-oi-yellow';
    if (pct >= 75 && oi < (secondHighestOI ?? Infinity)) return 'call-oi-bold';
    return '';
  };

  // === Put OI Classes ===
  const getPutOiClass = (oi) => {
    let highestOI = stats.highestPutOi;
    let secondHighestOI = stats.secondHighestPutOi;
    if (!highestOI || !oi) return '';
    const pct = (oi / highestOI) * 100;
    if (oi === highestOI) return 'put-oi-blue';
    if (oi === secondHighestOI && pct >= 75) return 'put-oi-yellow';
    if (pct >= 75 && oi < (secondHighestOI ?? Infinity)) return 'put-oi-bold';
    return '';
  };

  // === Call OI Change Classes ===
  const getCallOiChgClass = (val) => {
    let highestOIChg = stats.highestCallOiChg;
    let secondHighestOIChg = stats.secondHighestCallOiChg;
    if (!highestOIChg || !val) return '';
    const pct = (val / highestOIChg) * 100;
    if (val === highestOIChg) return 'call-oiChg-blue';
    if (val === secondHighestOIChg && pct >= 75) return 'call-oiChg-yellow';
    if (pct >= 75 && val < (secondHighestOIChg ?? Infinity)) return 'call-oiChg-bold';
    return (val < 0 && val < (secondHighestOIChg ?? Infinity)) ? 'text-danger' : 'text-success';
  };

  // === Put OI Change Classes ===
  const getPutOiChgClass = (val) => {
    let highestOIChg = stats.highestPutOiChg;
    let secondHighestOIChg = stats.secondHighestPutOiChg;
    if (!highestOIChg || !val) return '';
    const pct = (val / highestOIChg) * 100;
    if (val === highestOIChg) return 'put-oiChg-blue';
    if (val === secondHighestOIChg && pct >= 75) return 'put-oiChg-yellow';
    if (pct >= 75 && val < (secondHighestOIChg ?? Infinity)) return 'put-oiChg-bold';
    return (val < 0 && val < (secondHighestOIChg ?? Infinity)) ? 'text-danger' : 'text-success';
  };

  const getCallTikVolumeChangeClass = (callTikVolumeChange, highestCallTikVolumeChange, secondHighestCallTikVolumeChange) => {
    if (!highestCallTikVolumeChange || !callTikVolumeChange) return '';
    const pct = (callTikVolumeChange / highestCallTikVolumeChange) * 100;
    if (callTikVolumeChange === highestCallTikVolumeChange) return 'call-3M-volume-blue';
    if (callTikVolumeChange === secondHighestCallTikVolumeChange && pct >= 75) return 'call-3M-volume-yellow';
    if (pct >= 75 && callTikVolumeChange < (secondHighestCallTikVolumeChange ?? Infinity)) return 'call-volume-bold';
    return '';
  }

  // Call 3M Volume Change
  const getCall3MVolumeChangeClass = (call3MVolumeChange) => {
    let highest3MVolume = stats.highestCall3MVolumeChange;
    let secondHighest3MVolume = stats.secondHighestCall3MVolumeChange;
    if (!highest3MVolume || !call3MVolumeChange) return '';
    const pct = (call3MVolumeChange / highest3MVolume) * 100;
    if (call3MVolumeChange === highest3MVolume) return 'call-3M-volume-blue';
    if (call3MVolumeChange === secondHighest3MVolume && pct >= 75) return 'call-3M-volume-yellow';
    if (pct >= 75 && call3MVolumeChange < (secondHighest3MVolume ?? Infinity)) return 'call-volume-bold';
    return '';
  };

  // Call 3M OI Change
  const getCall3MOIChangeClass = (call3MOIChange) => {
    let highest3MOI = stats.highestCall3MOIChange;
    let secondHighest3MOI = stats.highestCall3MOIChange;
    if (!highest3MOI || !call3MOIChange) return '';
    const pct = (call3MOIChange / highest3MOI) * 100;
    if (call3MOIChange === highest3MOI) return 'call-3M-volume-blue';
    if (call3MOIChange === secondHighest3MOI && pct >= 75) return 'call-3M-volume-yellow';
    if (pct >= 75 && call3MOIChange < (secondHighest3MOI ?? Infinity)) return 'call-volume-bold';
    return (call3MOIChange < 0 && call3MOIChange < (secondHighest3MOI ?? Infinity)) ? 'text-danger' : 'text-success';
  };

  // Call 3M OI CHG Change
  const getCall3MOICHGChangeClass = (call3MOICHGChange) => {
    let highest3MOIChg = stats.highestCall3MOICHGChange;
    let secondHighest3MOIChg = stats.secondHighestCall3MOICHGChange;
    if (!highest3MOIChg || !call3MOICHGChange) return '';
    const pct = (call3MOICHGChange / highest3MOIChg) * 100;
    if (call3MOICHGChange === highest3MOIChg) return 'call-volume-blue';
    if (call3MOICHGChange === secondHighest3MOIChg && pct >= 75) return 'call-volume-yellow';
    if (pct >= 75 && call3MOICHGChange < (secondHighest3MOIChg ?? Infinity)) return 'call-volume-bold';
    return (call3MOICHGChange < 0 && call3MOICHGChange < (secondHighest3MOIChg ?? Infinity)) ? 'text-danger' : 'text-success';
  };


  // ================= PUT SIDE =================

  // Put Tik Volume Change
  const getPutTikVolumeChangeClass = (putTikVolumeChange) => {
    let highestTikVolumeChange = stats.highestPutTikVolumeChange;
    let secondHighestTikVolumeChange = stats.secondHighestPutTikVolumeChange;
    if (!highestTikVolumeChange || !putTikVolumeChange) return '';
    const pct = (putTikVolumeChange / highestTikVolumeChange) * 100;
    if (putTikVolumeChange === highestTikVolumeChange) return 'call-3M-volume-blue';
    if (putTikVolumeChange === secondHighestTikVolumeChange && pct >= 75) return 'call-3M-volume-yellow';
    if (pct >= 75 && putTikVolumeChange < (secondHighestTikVolumeChange ?? Infinity)) return 'call-volume-bold';
    return '';
  };

  // Put 3M Volume Change
  const getPut3MVolumeChangeClass = (put3MVolumeChange) => {
    let highestTikVolumeChange = stats.highestPut3MVolumeChange;
    let secondHighestTikVolumeChange = stats.secondHighestPut3MVolumeChange;
    if (!highestTikVolumeChange || !put3MVolumeChange) return '';
    const pct = (put3MVolumeChange / highestTikVolumeChange) * 100;
    if (put3MVolumeChange === highestTikVolumeChange) return 'call-3M-volume-blue';
    if (put3MVolumeChange === secondHighestTikVolumeChange && pct >= 75) return 'call-3M-volume-yellow';
    if (pct >= 75 && put3MVolumeChange < (secondHighestTikVolumeChange ?? Infinity)) return 'call-volume-bold';
    return '';
  };

  // Put 3M OI Change
  const getPut3MOIChangeClass = (put3MOIChange) => {
    let highest3MOI = stats.highestPut3MOIChange;
    let secondHighest3MOI = stats.secondHighestPut3MOIChange;
    if (!highest3MOI || !put3MOIChange) return '';
    const pct = (put3MOIChange / highest3MOI) * 100;
    if (put3MOIChange === highest3MOI) return 'call-3M-volume-blue';
    if (put3MOIChange === secondHighest3MOI && pct >= 75) return 'call-3M-volume-yellow';
    if (pct >= 75 && put3MOIChange < (secondHighest3MOI ?? Infinity)) return 'call-volume-bold';
    return (put3MOIChange < 0 && put3MOIChange < (secondHighest3MOI ?? Infinity)) ? 'text-danger' : 'text-success';
  };

  // Put 3M OI CHG Change
  const getPut3MOICHGChangeClass = (put3MOICHGChange) => {
    let highest3MOIChg = stats.highestPut3MOICHGChange;
    let secondHighest3MOIChg = stats.secondHighestPut3MOICHGChange;
    if (!highest3MOIChg || !put3MOICHGChange) return '';
    const pct = (put3MOICHGChange / highest3MOIChg) * 100;
    if (put3MOICHGChange === highest3MOIChg) return 'call-volume-blue';
    if (put3MOICHGChange === secondHighest3MOIChg && pct >= 75) return 'call-volume-yellow';
    if (pct >= 75 && put3MOICHGChange < (secondHighest3MOIChg ?? Infinity)) return 'call-volume-bold';
    return (put3MOICHGChange < 0 && put3MOICHGChange < (secondHighest3MOIChg ?? Infinity)) ? 'text-danger' : 'text-success';
  };

  const getCallTimeValueClass=(callTimeValue)=>{
    if(!callTimeValue) return '';
    return callTimeValue <0 ?'text-danger':'text-success';
  }

  const indexSpotPrice = Number(indexDayRangeData?.niftySpotPrice || 0);

  const previousDayHigh = Number(indexDayRangeData?.previousDayHigh || 0);
  const previousDayLow = Number(indexDayRangeData?.previousDayLow || 0);
  const previousDayClose = Number(indexDayRangeData?.previousDayClose || 0);
  const dayHigh = Number(indexDayRangeData?.dayHigh || 0);
  const dayLow = Number(indexDayRangeData?.dayLow || 0);

  const isNearPDH = previousDayHigh && Math.abs(previousDayHigh - indexSpotPrice) <= 20;
  const isNearPDL = previousDayLow && Math.abs(previousDayLow - indexSpotPrice) <= 20;
  const isNearPDC = previousDayClose && Math.abs(previousDayClose - indexSpotPrice) <= 20;
  const isNearDH = dayHigh && Math.abs(dayHigh - indexSpotPrice) <= 20;
  const isNearDL = dayLow && Math.abs(dayLow - indexSpotPrice) <= 20;
  // -------------------
  // Header Data
  // -------------------
  const headerData = [
    {
      label1: "Top-1",
      value1: indexDayRangeData ? Number(indexDayRangeData.dayTopOne || 0).toFixed(2) : "--",
      label2: "Top-2",
      value2: indexDayRangeData ? Number(indexDayRangeData.dayTopTwo || 0).toFixed(2) : "--",
    },
    {
      label1: "Bottom-1",
      value1: indexDayRangeData ? Number(indexDayRangeData.dayBottomOne || 0).toFixed(2) : "--",
      label2: "Bottom-2",
      value2: indexDayRangeData ? Number(indexDayRangeData.dayBottomTwo || 0).toFixed(2) : "--",
    },
    {
      label1: "RES",
      value1:
        getCallResistanceLogic(stats.highestCallVolStrike, stats.highestCallOiStrike, stats.spotPrice) + ' - ' +
        getCallResistanceWttAndWtb(getCallResistanceLogic(stats.highestCallVolStrike, stats.highestCallOiStrike, stats.spotPrice),
          stats.secondHighestCallVolStrike, stats.secondHighestCallVolume, stats.highestCallVolume), // just call function normally
      label2: "SUP",
      value2: getPutSupportLogic(stats.highestPutVolStrike, stats.highestPutOiStrike, stats.spotPrice) + ' - ' +
        getPutSupportWttAndWtb(stats.secondHighestPutVolStrike, stats.secondHighestPutVolume, getPutSupportLogic(stats.highestPutVolStrike, stats.highestPutOiStrike, stats.spotPrice))

    },
     {
      label1: "PDH",
      value1: indexDayRangeData ? Number(indexDayRangeData.previousDayHigh || 0).toFixed(2) : "--", highlight: isNearPDH,
      label2: "PDL",
      value2: indexDayRangeData ? Number(indexDayRangeData.previousDayLow || 0).toFixed(2) : "--", highlight2: isNearPDL,   // 👈 for PDL
    },
    {
      label1: "PDC",
      value1: indexDayRangeData ? Number(indexDayRangeData.previousDayClose || 0).toFixed(2) : "--", highlight: isNearPDC,
      label2: "OPEN",
      value2: indexDayRangeData ? Number(indexDayRangeData.niftyOpenPrice || 0).toFixed(2) : "--",
    },
    {
      label1: "DH",
      value1: indexDayRangeData ? Number(indexDayRangeData.dayHigh || 0).toFixed(2) : "--", highlight: isNearDH,
      label2: "DL", value2: indexDayRangeData ? Number(indexDayRangeData.dayLow || 0).toFixed(2) : "--", highlight2: isNearDL,
    },
    {
      label1: "ExpDate",
      value1: indexDayRangeData?.expiryDate || "--",
      label2: "DateTime",
      value2: indexDayRangeData?.currentDateTime || "--",
    },
  ];

usePageTitle(indexDayRangeData?.niftySpotPrice ?? "N/A", indexDayRangeData?.expiryDate ?? "N/A");

  // -------------------
  // JSX Table Section (remains unchanged)
  // -------------------
  return (
    <div className="fifth-nifty-page">
      <header className="header">
        <nav className="nav-container">
          <div className="left-nav header-flex">
            <div className="logo-container">
              <img
                src="/assets/images/noptionwave-logo-1.png"
                className="header-logo"
                alt="noptionwave logo"
              />
              {/* <span className="index-name">{indexSymbolName}</span> */}
              <select name="indexFilter" className="index-filter" value={indexFilterValueChanges} onChange={handleIndexFilterValueChange} style={{ cursor: "pointer" }}>
                <option value="NSE:NIFTY">NIFTY</option>
                <option value="BSE:SENSEX">SENSEX</option>
                <option value="NSE:BANKNIFTY">BANKNIFTY</option>
                {/* <option value="NSE:FINNIFTY">FINNIFTY</option>
                <option value="NSE:MIDCPNIFTY">MIDCPNIFTY</option> */}
              </select>
              
            </div>
            {headerData.map((item, idx) => (
              <div className="header-item" key={idx}>
              {/* ===== LINE 1 ===== */}
                {(item.label1 != null || item.value1 != null) && (
                  <span className={`header-line ${item.highlight ? "blink-highlight" : ""}`}>
                    {item.label1 != null && item.label1 !== "" && (
                      <>
                        {item.label1}
                        {item.value1 != null && " : "}
                      </>
                    )}

                    {item.value1 != null && item.value1}
                  </span>
                )}

                {/* ===== LINE 2 ===== */}
                {(item.label2 != null || item.value2 != null) && (
                  <span className={`header-line ${item.highlight2 ? "blink-highlight" : ""}`}>
                    {item.label2 != null && item.label2 !== "" && (
                      <>
                        {item.label2}
                        {item.value2 != null && " : "}
                      </>
                    )}
                    {item.value2 != null && item.value2}
                  </span>
                )}
              </div>
            ))}
          </div>
        </nav>
      </header>

      <div className="table-container">
        <table className="responsive-table table-bordered text-center sticky-header">
          <thead>
            <tr>
              <th>IV</th>
              <th>OICHG</th>
              <th>OI</th>
              <th>VOL</th>
              <th>LTP</th>
               <th>REV</th>
              <th>
                <select name="strikeFilter" className="strike-filter" value={selectedStrikeFilter} onChange={handleStrikeFilterChange} style={{ cursor: "pointer" }}>
                  <option value="6">6TH</option>
                  <option value="3">3RD</option>
                </select>
              </th>
               <th>REV</th>
              <th>LTP</th>
              <th>VOL</th>
              <th>OI</th>
              <th>OICHG</th>
              <th>IV</th>
            </tr>
          </thead>
          <tbody>
            {niftyOptionDataModelList.length > 0 ? (
              niftyOptionDataModelList.map((row, idx) => {
                const nextRow = niftyOptionDataModelList[idx + 1];
                const spot = options?.[indexFilterValueChanges]?.indexLiveDataModel?.lp;

                const isSpotBetween =
                  nextRow &&
                  spot != null &&
                  spot > Math.min(row.strikePrice, nextRow.strikePrice) &&
                  spot < Math.max(row.strikePrice, nextRow.strikePrice);

                const insertAbove = idx === aboveSpotIndex;
                const insertBelow = idx === belowSpotIndex;

                return (
                  <React.Fragment key={idx}>
                    {/* Original row */}
                    <tr>
                      <td>
                        
                        {Number(row.ceIV).toFixed(2) ?? "--"}
                      </td>
                     
                      
                      <td className={getCallOiChgClass(row.ceOIChg)}>
                        {Number(row.ceOIChg).toFixed(0) ?? "--"}
                        <br />
                        {getCallOiChgPercentage(row.ceOIChg)}
                      </td>
                      <td className={getCallOiClass(row.ceOI)}>
                        {Number(row.ceOI).toFixed(0) ?? "--"}
                        <br />
                        {getCallOiPercentage(row.ceOI)}
                      </td>
                      <td className={getCallVolumeClass(row.ceVolume)}>
                        {row.ceVolume ?? "--"}
                        <br />
                        {getCallVolumePercentage(row.ceVolume)}
                      </td>
                     
                      <td>{Number(row.ceLtp).toFixed(2) ?? "--"}</td>
                      <td> {Number(row.ceReversal).toFixed(2) ?? "--"} </td>
                      <td className="strike-price-color">{row.strikePrice ?? "--"}</td>
                      <td>{Number(row.peReversal).toFixed(2) ?? "--"}</td>
                      <td>{Number(row.peLtp).toFixed(2) ?? "--"} </td>
                      
                      <td className={getPutVolumeClass(row.peVolume)}>
                        {row.peVolume ?? "--"}
                        <br />
                        {getPutVolumePercentage(row.peVolume)}
                      </td>
                      <td className={getPutOiClass(row.peOI)}>
                        {Number(row.peOI).toFixed(0) ?? "--"}
                        <br />
                        {getPutOiPercentage(row.peOI)}
                      </td>
                      <td className={getPutOiChgClass(row.peOIChg)}>
                        {Number(row.peOIChg).toFixed(0) ?? "--"}
                        <br />
                        {getPutOiChgPercentage(row.peOIChg)}
                      </td>
                                         
                      
                      <td>
                      
                        {Number(row.peIV).toFixed(2) ?? "--"}
                      </td>
                    </tr>

                    {insertBelow && (
                      <tr className="fifth-strike-row ">
                        <td colSpan="2" >5th Strike OICHG {Number(stats5thStrikeData.call5thStrikeTotalOICHGSum).toFixed(0) ?? "--"} </td>
                        <td colSpan="2">5th Strike OI {Number(stats5thStrikeData.call5thStrikeTotalOISum).toFixed(0) ?? "--"} </td>
                        <td colSpan="2" >5th Strike VOL {Number(stats5thStrikeData.call5thStrikeTotalVolumeSum).toFixed(0) ?? "--"}</td>
                        {/* <td colSpan="1">
                          {row.spotPrice}
                        </td> */}
                        <td colSpan="2">5th Strike Vol {Number(stats5thStrikeData.put5thStrikeTotalVolumeSum).toFixed(0) ?? "--"} </td>
                        <td colSpan="2">5th Strike OI {Number(stats5thStrikeData.put5thStrikeTotalOISum).toFixed(0) ?? "--"}</td>
                        <td colSpan="2">5th Strike OICHG {Number(stats5thStrikeData.put5thStrikeTotalOISum).toFixed(0) ?? "--"}</td>
                      </tr>
                    )}

                    {isSpotBetween && (
                      <tr className="spot-line">
                        <td colSpan="2">
                          OICHG - {stats.highestCallOiChgStrike} -
                          {getCallResistanceOIChgWttAndWtb(stats.secondHighestCallOiChgStrike, stats.secondHighestCallOiChg, stats.highestCallOiChgStrike)}
                        </td>
                        <td colSpan="2">
                          OI - {stats.highestCallOiStrike} -
                          {getCallResistanceOIWttAndWtb(stats.secondHighestCallOiStrike, stats.secondHighestCallOi, stats.highestCallOiStrike)}
                        </td>
                        <td colSpan="2">
                          RES - {getCallResistanceLogic(stats.highestCallVolStrike, stats.highestCallOiStrike, stats.spotPrice)}  -
                          {getCallResistanceWttAndWtb(getCallResistanceLogic(stats.highestCallVolStrike, stats.highestCallOiStrike, stats.spotPrice),
                            stats.secondHighestCallVolStrike, stats.secondHighestCallVolume, stats.highestCallVolume)}
                        </td>
                        <td colSpan="1">{row.spotPrice}</td>
                        <td colSpan="2">
                          SUP - {getPutSupportLogic(stats.highestPutVolStrike, stats.highestPutOiStrike, stats.spotPrice)}  -
                          {getPutSupportWttAndWtb(getPutSupportLogic(stats.highestPutVolStrike, stats.highestPutOiStrike, stats.spotPrice),
                            stats.secondHighestPutVolStrike, stats.secondHighestPutVolume, stats.highestPutVolume)}
                        </td>
                        <td colSpan="2">
                          OI - {stats.highestPutOiStrike} -
                          {getPutSupportOIWttAndWtb(stats.secondHighestPutOiStrike, stats.secondHighestPutOi, stats.highestPutOiStrike)}
                        </td>
                        <td colSpan="2">
                          OICHG - {stats.highestPutOiChgStrike} -
                          {getPutSupportOIChgWttAndWtb(stats.secondHighestPutOiChgStrike, stats.secondHighestPutOiChg, stats.highestPutOiChgStrike)}
                        </td>
                      </tr>
                    )}

                    {insertAbove && (
                      <tr className="fifth-strike-row">
                        <td colSpan="2">5th Strike PE-CE-OICHG ({Number(stats5thStrikeData.put5thStrikeTotalOISum - stats5thStrikeData.call5thStrikeTotalOISum).toFixed(0)})</td>
                        <td colSpan="2">5th Strike PCR-OICHG ({Number(stats5thStrikeData.put5thStrikeTotalOISum / stats5thStrikeData.call5thStrikeTotalOISum).toFixed(2)})</td>
                        <td colSpan="2">5th Strike PE-CE-VOLUME ({Number(stats5thStrikeData.put5thStrikeTotalVolumeSum - stats5thStrikeData.call5thStrikeTotalVolumeSum).toFixed(0)})</td>
                        {/* <td colSpan="1">{row.spotPrice}</td> */}
                        <td colSpan="2">5th Strike PCR-VOLUME ({Number(stats5thStrikeData.put5thStrikeTotalVolumeSum / stats5thStrikeData.call5thStrikeTotalVolumeSum).toFixed(2)})</td>
                        <td colSpan="2">5th Strike PE-CE-OI ({Number(stats5thStrikeData.put5thStrikeTotalOICHGSum - stats5thStrikeData.call5thStrikeTotalOICHGSum).toFixed(0)})</td>
                        <td colSpan="2">5th Strike PCR-OI ({Number(stats5thStrikeData.put5thStrikeTotalOICHGSum / stats5thStrikeData.call5thStrikeTotalOICHGSum).toFixed(2)})</td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan="17">Waiting for live data...</td>
              </tr>
            )}
          </tbody>
          <tfoot className="fixed-footer">
            <tr className="footer-left">
              <td colSpan="2">Total-OICHG-SUM ({Number(stats.callTotalOICHGSum).toFixed(0)})</td>
              <td colSpan="2">Total-OI-SUM ({stats.callTotalOISum})</td>
              <td colSpan="2">Total-VOL-SUM ({stats.callTotalVolumeSum})</td>
              <td colSpan="1">PCR ({Number(stats.putTotalOISum - stats.callTotalOISum).toFixed(0)})</td>
              <td colSpan="2">Total-VOL-SUM ({stats.putTotalVolumeSum})</td>
              <td colSpan="2">Total-OI-SUM ({stats.putTotalOISum})</td>
              <td colSpan="2">Total-OICHG-SUM ({Number(stats.putTotalOICHGSum).toFixed(2)})</td>
            </tr >
            
          </tfoot>

        </table>
      </div>
    </div>
  );
}
